/* eslint-disable @typescript-eslint/no-unused-vars */
import _ from 'underscore';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '@bingads-webui-campaign-react/router';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { SimpleSummaryBar } from '@bingads-webui-campaign-react/summary-bar';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { withScope } from '@bingads-webui-react/scope-service';

export const Loader = (props) => {
  const {
    siteMap,
    backButtonText,
    backButtonUrl,
    updateAvailability,
    scope,
    i18n,
    isVisible,
    ...others
  } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });
  const pathname = `/campaign/vnext/negativekeywordlistslibrary?uid=${scope.values.uid}&cid=${scope.values.cid}&aid=${scope.values.aid}`;

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });

  if (selectedParent) {
    const defaultSummaryBarFallback = (
      <SimpleSummaryBar
        selectedParent={selectedParent}
        backButtonText={i18n.getString('Back to negative keywords lists')}
        backButtonUrl={pathname}
        breadCrumbText={i18n.getString(_TL_('Negative Keyword Lists'))}
        {...others}
      />
    );

    if (scope.values.nkl && isVisible) {
      return (
        <CampaignOData
          call={({ currentAccount }) => currentAccount.NegativeKeywordLists.get()}
          escapeHatch={({ currentAccount }) => (currentAccount ? undefined : { value: defaultSummaryBarFallback })}
          fallback={defaultSummaryBarFallback}
          // If the list name call fails, show empty string.
          onError={() => defaultSummaryBarFallback}
        >
          {
            (response) => {
              const predicate = item => item.Id === scope.values.nkl;

              if (response.value && _.find(response.value, predicate)) {
                const list = _.find(response.value, predicate);
                const additionalItems = [];
                additionalItems.push({
                  key: 'item',
                  text: list.Name,
                  'aria-label': i18n.getString(_TL_('Negative Keyword List Name')),
                });

                return (
                  <SimpleSummaryBar
                    selectedParent={selectedParent}
                    backButtonText={i18n.getString(_TL_('Back to negative keywords lists'))}
                    backButtonUrl={pathname}
                    breadCrumbText={i18n.getString(_TL_('Negative Keyword Lists'))}
                    additionalItems={additionalItems}
                    {...others}
                  />
                );
              }

              return defaultSummaryBarFallback;
            }
          }
        </CampaignOData>
      );
    }

    return defaultSummaryBarFallback;
  }

  return null;
};

Loader.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  siteMap: siteMapPropType.isRequired,
  backButtonText: PropTypes.string,
  backButtonUrl: PropTypes.string,
  updateAvailability: PropTypes.func,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      selListId: PropTypes.number,
    }).isRequired,
  }).isRequired,
  isVisible: PropTypes.bool.isRequired,
};

Loader.defaultProps = {
  backButtonText: null,
  backButtonUrl: null,
  updateAvailability: _.noop,
};

export const NegativeKeywordsListDetailsLoader = withScope(withRouter(React.memo(Loader)));
